module.exports = __webpack_public_path__ + "static/media/loading-icon.af24a701.gif";